import { useEffect, useState } from 'react';
import { Slider } from '@/components';

interface SliderFilterProps {
  title: string;
  min?: number;
  max?: number;
  step?: number;
  value: [number, number];
  onValueCommit: (value: [number, number]) => void;
}

export const SliderFilter = ({ title, min = 0, max = 100, step = 1, value, onValueCommit }: SliderFilterProps) => {
  const [[start, end], setStartAndEnd] = useState(value);

  useEffect(() => {
    if (value[0] === start && value[1] === end) return;
    setStartAndEnd(value);
  }, [value]);

  return (
    <div className="px-[1px] pb-4">
      <div className="flex flex-col">
        <div className="mb-2 flex items-center gap-1 text-base text-secondary-grey-02">
          Between
          <span className="text-xl font-semibold text-black">
            {title === 'Indicative course fees' && '$'}
            {start}
          </span>
          and
          <span className="text-xl font-semibold text-black">
            {title === 'Indicative course fees' && '$'}
            {end}
          </span>
        </div>
        <Slider
          key={value.toString()} // force re-mount on slider change as there is a bug with radix slider not respective value updates
          defaultValue={value}
          min={min}
          max={max}
          step={step}
          onValueChange={(value) => setStartAndEnd(value as [number, number])}
          onValueCommit={(value) => onValueCommit(value as [number, number])}
        />
      </div>
    </div>
  );
};
